<template>
    <span>{{ formattedAmount }}{{ suffix }}</span>
</template>

<script>
import { toCurrency } from "../utils/formatter";

export default {
    name: "Pula",
    props: {
        amount: {
            type: Number
        },
        suffix: String
    },
    computed: {
        formattedAmount() {
            if (this.amount || this.amount === 0) {
                return toCurrency(this.amount);
            }
            return "-";
        }
    }
};
</script>

<style scoped></style>
